<template>
  <v-navigation-drawer
    :permanent="historyDrawer"
    width="100%"
    class="drawer-flex d-flex flex-column fill-height"
    :class="{ 'px-8': hasChatHistory }"
    :stateless="true"
  >
    <v-container
      v-if="!hasChatHistory"
      fluid
      fill-height
      class="pa-4 d-flex align-center justify-center"
    >
      <v-row
        justify="center"
        align="center"
      >
        <v-col
          class="text-center"
        >
          <v-icon
            :size="$isMobile ? 50 : 70"
            color="primary-grey"
            class="mb-4"
          >
            mdi-history
          </v-icon>
          <div class="text-h6 justify-center primary-grey--text mb-2">
            History is empty
          </div>
          <div class=" text-body-1 primary-grey--text">
            Start chatting to see recent questions and pinned answers
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-sheet
      v-else
      fluid
      class="px-0 fill-height"
    >
      <div
        class="history-sections d-flex flex-column"
        :class="layoutClass"
      >
        <section
          v-show="pinnedAnswers.length"
          class="section"
        >
          <div class="list-wrap">
            <v-list
              subheader
              class="pb-0"
            >
              <v-subheader class="text-h6 px-0 white primary-grey--text history-section-header">
                Pinned Answers ({{ pinnedAnswers.length }})
              </v-subheader>

              <template v-for="(item, index) in pinnedAnswers">
                <v-list-item
                  :key="'pin-' + index"
                  class="py-0"
                  style="cursor: pointer;"
                  @click="$emit('show-answer', item)"
                >
                  <v-list-item-icon class="px-0 mr-2">
                    <v-icon color="primary">
                      mdi-pin-outline
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content class="mx-0 flex-grow-1">
                    <v-list-item-title class="text-body-2 text-wrap">
                      {{ item.displayQuestion }}
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <span class="text-caption primary-grey--text pl-2">
                      {{ formattedDate(item.created_at) }}
                    </span>
                  </v-list-item-action>
                </v-list-item>
                <v-divider :key="'divider-pinned-' + index" />
              </template>
            </v-list>
          </div>
        </section>

        <section
          v-show="recentQuestions.length"
          class="section"
        >
          <div class="list-wrap">
            <v-list
              subheader
              class="mt-0"
            >
              <v-subheader class="text-h6 px-0 white primary-grey--text history-section-header">
                Recent Questions ({{ recentQuestions.length }})
              </v-subheader>

              <template v-for="(item, index) in recentQuestions">
                <v-list-item
                  :key="'recent-' + index"
                  class="py-0"
                  style="cursor: pointer;"
                  @click="$emit('show-answer', item)"
                >
                  <v-list-item-content class="px-0 mr-n6 flex-grow-1">
                    <v-list-item-title class="text-body-2 text-wrap">
                      {{ item.displayQuestion }}
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <span class="text-caption primary-grey--text pl-2">
                      {{ formattedDate(item.created_at) }}
                    </span>
                  </v-list-item-action>
                </v-list-item>
                <v-divider :key="'divider-recent-' + index" />
              </template>
            </v-list>
          </div>
        </section>
      </div>
    </v-sheet>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import formattedDate from './data/helpers';

export default {
  name: 'ChatHistoryDrawer',
  props: {
    historyDrawer: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    ...mapState('chatbot', ['chatHistory']),
    ...mapGetters('chatbot', ['hasChatHistory']),

    pinnedAnswers() {
      return this.chatHistory.pinnedQuestions || [];
    },

    recentQuestions() {
      return this.chatHistory.recentQuestions || [];
    },

    layoutClass() {
      const hasPinned = this.pinnedAnswers.length > 0;
      const hasRecent = this.recentQuestions.length > 0;
      return hasPinned && hasRecent ? 'split' : 'single';
    },
  },

  methods: {
    formattedDate,
  },
};
</script>

<style scoped>
.drawer-flex ::v-deep .v-navigation-drawer__content {
  overflow: hidden;
  height: 100%;
}

.history-sections {
  gap: 16px;
  height: 100%;
  min-height: 0;
}

.history-sections.single .section,
.history-sections.split .section {
  flex: 1 1 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.list-wrap {
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
}

.history-section-header {
  position: sticky;
  top: 0;
  z-index: 1;
}
</style>
